module.exports = __webpack_public_path__ + "media/images/about-us/works/confirmation-d883f33116525606795ca4f153eaa8d1.png";